<edit-item-group
	[propertyGroup]="propertyGroup"
	[parentForm]="assetForm"
	[mode]="Mode.Asset"
>
</edit-item-group>
<div class="info-section-header">
	{{ deliverablePartnersTitle }}
	<div class="add-edit-review-button" (click)="addPartner()">
		+{{ Loc(LocalizedTextIds.Add) }}
	</div>
</div>
<table>
	<tr>
		<th>{{ nameLabel }}</th>
		<th>{{ roleLabel }}</th>
		<th></th>
	</tr>
	@for(partner of asset.deliverablePartners; track partner.partnerId) {
	<tr (click)="editPartner($event, partner.partnerId)">
		<td class="header">
			<span
				[ngClass]="{ deleted: partner.isDeleted }"
				[hidden]="isEditingPartner(partner.partnerId) && inEditMode"
				>{{ partner.partnerName }}</span
			>
			<input
				[hidden]="!isEditingPartner(partner.partnerId)"
				(change)="onNameChange($event)"
				[(ngModel)]="partner.partnerName"
				maxlength="100"
			/>
		</td>
		<td>
			<span
				[hidden]="isEditingPartner(partner.partnerId)"
				[ngClass]="{ deleted: partner.isDeleted }"
				>{{ partner.role }}</span
			>
			<select
				[hidden]="!isEditingPartner(partner.partnerId)"
				[(ngModel)]="partner.role"
				(change)="onRoleChange($event)"
			>
				@for(role of roles; track role){
				<option [value]="role">{{ role }}</option>
				}
			</select>
		</td>
		<td
			(click)="togglePartnerDeletion($event, partner.partnerId)"
			class="action"
		>
			{{ removeOrRestoreLabel(partner.isDeleted) }}
		</td>
	</tr>
	}
</table>
<div class="buttonrow">
	@if(selfUpdateMode === SelfUpdateModes.Edit){
	<action-button type="submit" (buttonClick)="closeTab()">
		{{ Loc(LocalizedTextIds.Back) }}
		<div class="right-arrow"></div>
	</action-button>
	} @else {
	<action-button
		type="decline"
		(buttonClick)="declineAsset()"
		class="decline-button"
	>
		{{ Loc(LocalizedTextIds.Decline) }}
	</action-button>
	<action-button type="approve" (buttonClick)="approveAsset()">
		{{ Loc(LocalizedTextIds.Approve) }}
	</action-button>
	}
</div>
